import React from "react";
import update from "immutability-helper";
import axios from "axios";

class BasketSummary extends React.Component {
  constructor(props) {
    super(props);
    this.getBasketSummary = this.getBasketSummary.bind(this);
    this.removeLine = this.removeLine.bind(this);
    this.amendQuantity = this.amendQuantity.bind(this);
    this.state = {
      loading: true,
      contents: [],
      num_lines: 0
    };
  }

  componentDidMount() {
    this.getBasketSummary();
    PubSub.subscribe("BASKET_UPDATE", () => {
      this.getBasketSummary();
    });
  }

  amendQuantity(line, change) {
    let new_quantity;
    this.setState({ loading: true });
    let basket_line = _.findIndex(this.state.contents, l => {
      return l.id === line;
    });

    switch (change) {
      case "increment":
        new_quantity = this.state.contents[basket_line].quantity += 1;
        break;
      case "decrement":
        new_quantity = this.state.contents[basket_line].quantity -= 1;
        break;
    }

    if (new_quantity < 1) {
      new_quantity = 1;
    }

    const newContents = update(this.state.contents, {
      [basket_line]: { quantity: { $set: new_quantity } }
    });
    this.setState({ contents: newContents });

    axios
      .patch(
        "/basket/update_line_quantity",
        {
          line,
          quantity: new_quantity
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        }
      )
      .then(() => {
        this.setState({ loading: false });
        PubSub.publish("BASKET_UPDATE");
      });
  }

  removeLine(line) {
    axios
      .delete("/basket/remove_line", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: {
          basket_line: line
        }
      })
      .then(() => {
        PubSub.publish("BASKET_UPDATE");
      });
  }

  getBasketSummary() {
    axios
      .get("/basket", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
      .then(response => {
        this.setState({
          loading: false,
          num_lines: response.data.basket.num_lines,
          contents: response.data.basket.contents
        });

        if (this.state.num_lines === 0) {
          document
            .querySelector(".basket-quote-request")
            .classList.add("basket-quote-request--hidden");
        } else {
          document
            .querySelector(".basket-quote-request")
            .classList.remove("basket-quote-request--hidden");
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          num_lines: 0,
          contents: []
        });
      });
  }

  render() {
    let noResults = "";
    if (this.state.contents.length === 0) {
      noResults = (
        <div className="basket-empty">
          <i className="material-icons"></i>
          You have no items in your basket.
        </div>
      );
    }
    return (
      <div className="basket-contents">
        <ul className="basket-items">
          {this.state.contents.map((product, i) => {
            return (
              <li className="basket-item" key={i}>
                <img
                  className="basket-item__image img-fluid"
                  src={product.image.replace("medium", "small")}
                />
                <div className="basket-item__info">
                  <h4 className="basket-item__title">{product.product}</h4>
                  <ul className="basket-item__codes">
                    <li>
                      <span>Part Code:</span>&nbsp;{product.catalogue}
                    </li>
                    <li>
                      <span>Stock Code:</span>&nbsp;{product.stock_code}
                    </li>
                  </ul>
                </div>
                <div className="quantity-controls basket-item__quantity-controls">
                  <span
                    className="quantity-control quantity-control--decrement"
                    onClick={() => this.amendQuantity(product.id, "decrement")}
                  >
                    <i className="material-icons selected">&#xE15B;</i>
                  </span>
                  <input type="text" readOnly value={product.quantity} />
                  <span
                    className="quantity-control quantity-control--increment"
                    onClick={() => {
                      this.amendQuantity(product.id, "increment");
                    }}
                  >
                    <i className="material-icons selected">&#xE145;</i>
                  </span>
                </div>
                <div
                  className="basket-item__remove-item"
                  onClick={() => {
                    this.removeLine(product.id);
                  }}
                >
                  <i className="material-icons">&#xE5C9;</i>
                  <span>Remove</span>
                </div>
              </li>
            );
          })}
        </ul>
        {noResults}
      </div>
    );
  }
}

export { BasketSummary as default };
